import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import ContainerCard from "../components/global/containerCard";
import Meta from "../components/global/meta";
import Loader from "../components/global/loader";
import { Input, Button } from "@speedoc/design-assets/";
import { createPasswordToken } from "../services/userService";
import URI from "urijs";

export default () => {
  const location = useLocation();
  const [wasSubmitted, setWasSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState();
  const { fromAdmin, fromProvider } = new URI(location.pathname + location.search).search(true);
  const onSubmit = async e => {
    setIsSubmitting(true);
    setError("");
    e.preventDefault();
    const email = e.target.email.value;
    if (email.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)) {
      try {
        await createPasswordToken({ email, fromAdmin, fromProvider });
        setWasSubmitted(true);
      } catch (err) {
        setError(err.response ? err.response.data : err.toString());
      } finally {
        setIsSubmitting(false);
      }
    } else {
      setIsSubmitting(false);
      setError("Please enter a valid email.");
    }
  };

  return (
    <div id="passwordChange">
      <Meta title="Password change" seo={{ index: false }} />

      <ContainerCard>
        <div className="title">Enter your email to change your password</div>
        {!wasSubmitted ? (
          <form onSubmit={onSubmit}>
            <Input type="email" name="email" required placeholder="Your email" />
            <Button disabled={isSubmitting} type="submit">
              {isSubmitting ? <Loader /> : "Confirm"}
            </Button>
          </form>
        ) : (
          <div className="submitted">
            <p>An email containing a link to reset your password has been sent.</p>
          </div>
        )}
        <p className="error">{error}</p>
      </ContainerCard>
    </div>
  );
};
